import styled from '@emotion/styled';
import { H3, H1 } from 'ds/components/typography';
import { typographyLineHeightCfg, typographyFontSizeCfg } from 'ds/components/typography/types';

export const SearchContentWrapper = styled.div`
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    padding: ${theme.spacing(3)};
  `}
  ${({ theme }) => theme.media.showAt({ from: 3 })`
    padding: ${theme.spacing(4)} ${theme.spacing(3)} ${theme.spacing(3)};
  `}
`;

export const ContentControls = styled.div`
  margin-bottom: ${props => props.theme.spacing(1)};
`;

export const ListingCardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  ${({ theme }) => theme.media.showAt({ to: 2 })`
    gap: ${theme.spacing(1.5)} ${theme.spacing(0.5)};
  `}

  ${({ theme }) => theme.media.showAt({ from: 3 })`
    gap: ${theme.spacing(1)} ${theme.spacing(0.5)};
  `}
`;

export const ListingsCountLabel = styled(H3.withComponent('h2'))``;

export const PageH1 = styled(H1)`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey1};
    line-height: ${typographyLineHeightCfg.h1.mobile}px;
    font-size: ${typographyFontSizeCfg.h1.mobile}px;
  `}

  ${({ theme }) => theme.media.showAt({ from: 3 }) `
    line-height: ${typographyLineHeightCfg.h1.mobile}px;
    font-size: ${typographyFontSizeCfg.h1.mobile}px;
  `}

  ${({ theme }) => theme.media.showAt({ to: 2 }) `
    line-height: ${typographyLineHeightCfg.h2.mobile}px;
    font-size: ${typographyFontSizeCfg.h2.mobile}px;
  `}
  > span {
    color: transparent;
    user-select: none;
  }
`;

export const ListingSortWrapper = styled.div<{ stickyMode?: boolean; hasShadow?: boolean }>(({ theme, stickyMode, hasShadow }) => `
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  ${stickyMode ? `
    position: sticky;
    margin: 0 -24px;
    width: calc(100% + 48px);
    top: 121px;
    background: ${theme.colors.neutrals.white};
    z-index: 11;
    padding: ${theme.spacing(1, 3)};
    box-shadow: ${hasShadow ? theme.shadow.level3 : 'none'};
  ` : ''}

  ${theme.media.showAt({ to: 2 })`
    padding: ${theme.spacing(1.5)} 0 0;
    margin-bottom: -${theme.spacing(0.5)};
  `}
  ${theme.media.showAt({ at: 3 })`
    padding: ${theme.spacing(3)} 0 ${theme.spacing(1)};
  `}
  ${theme.media.showAt({ from: 4 })`
    padding: ${theme.spacing(2)} 0 ${theme.spacing(1)};
  `}
`);

export const MadadWinnerWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  min-width: 100%;
`;

export const ListingSeparatorH3Header = styled(H3)<{withTopBorder?: boolean}>`
  ${({ theme, withTopBorder }) => `
    line-height: ${typographyLineHeightCfg.h2.mobile}px;
    font-size: ${typographyFontSizeCfg.h2.mobile}px;
    padding-top: ${theme.spacing(1)};
    width: 100%;
    ${withTopBorder ? `
      margin-top: ${theme.spacing(3)};
      padding-top: ${theme.spacing(3)};
      border-top: 1px solid ${theme.colors.neutrals.grey8};
    ` : ''}
  `}
`;

ListingSeparatorH3Header.defaultProps = {
  weight: 'bold',
};
